module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"zonesSummaryHeader":"Fläche & Nutzung","missingZones":"Keine Zonen definiert","hasUnknownZoneUsages":"Nutzung fehlt","missingEnergyArea":"Fläche fehlt","usageEstimatedLabel":"Nutzung unsicher","areaEstimatedLabel":"Flächen unsicher","areaGisLabel":"Flächen aus GIS-Daten abgeleitet","areaEbfLabel":"m² EBF"}}')
  delete Component.options._Ctor
}
